const path = location.hostname === 'staging.livas.lt' ? '' : '/_dev';

export const environment = {
  production: true,
  oauth_id: 'DFCE1imiTddXQvFfIVf0D5wuhNeVq8DUSlBQWs23',
  oauth_secret:
    'mBxiABY2mZmIUbn8Ds2qNzrZJP0OjZ5N3AmNIUXjNixmDeeS10msbHmZkj4lhoqQqgs6psyasbRdd4ffokAv09otKaWXjoXagBjpGMWpwWznEix3y8hnQzeMMMkK4j5B',
  url: 'https://boris-staging-api.workis.lt',
  livasAPIBase: path,
  livasAPIBaseLT: 'https://edla.biuro.lt/_dev',
  livasAPIBaseLV: 'https://edla.biuro.lt/_dev',
  livasAPIBaseEE: 'https://edla.biuro.lt/_dev',
  // relative: each instance serves all countries; call whichever embedded the iframe
  livasAPIBaseLTV3: `${path}/lt/jobs/api/v3`,
  livasAPIBaseLVV3: `${path}/lv/jobs/api/v3`,
  livasAPIBaseEEV3: `${path}/ee/jobs/api/v3`,
  livasAPIBaseGiGroupV3: `${path}/gi-group/jobs/api/v3`,
  edlaAPIBase: 'https://edla.biuro.lt/_dev',
  env: 'staging',
  googleMapsApiKey: 'AIzaSyAYdYFM5OLlhA1teNMLZYFfz-EISrSZkY4',
};
